export default __webpack_public_path__ + "static/custom-tooltips-96e4935bcf7a8da27bd43f8a60df3ad4.png";